import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { SignInMethodOption, SignInVerification } from '../../../../entities/SignInMethod';
import CodeMethodStepViewModel from './viewModel';
import { CardHeader, ContinueButton, ErrorText, IconShape, Message, MethodCard, MethodTitle, MethodValue } from './styled';

type CodeMethodStepProps = {
  verifyData: SignInVerification;
  onMethodSelected: (method: SignInMethodOption) => void;
  onLoadingChange: (isLoading: boolean) => void;
  onContinueWithoutLogin: () => void;
};

export default function CodeMethodStep({
  verifyData,
  onMethodSelected,
  onLoadingChange,
  onContinueWithoutLogin
}: CodeMethodStepProps) {
  const { options, isLoading, hasError, errorMessage, handleSelect, getTypeIcon } = CodeMethodStepViewModel({
    verifyData,
    onMethodSelected,
    onLoadingChange
  });

  return (
    <>
      <Message>Receba seu código por:</Message>

      {options.map(option => (
        <MethodCard key={option.type} disabled={isLoading} onClick={() => handleSelect(option)}>
          <CardHeader>
            <IconShape>{getTypeIcon(option.type)}</IconShape>
            <MethodTitle>{option.label}</MethodTitle>
            <ChevronRightIcon />
          </CardHeader>
          <MethodValue>{option.value}</MethodValue>
        </MethodCard>
      ))}

      {hasError && <ErrorText>{errorMessage}</ErrorText>}

      <ContinueButton variant="inline" color="primary" onClick={onContinueWithoutLogin}>
        Continuar sem login
      </ContinueButton>
    </>
  );
}
